'use client'

/* eslint-disable react/function-component-definition */
import React from 'react'
import {
  BOTTOM_NAVIGATION_ITEM_PROPERTIES,
  BOTTOM_NAVIGATION_ITEMS,
} from '@components/Ackodrive/common/bottomNavigationMobile.constants'
import { BottomNavigationWrapper } from './styles'
import NavigationItem from './NavigationItem'

export interface INavigationItem {
  title: string
  Icon: React.ElementType
  isActive: boolean
  url: string
  eventName: string
  eventProperties?: { [key: string]: string }
}

export default function BottomNavigationMobile() {
  const activeTab = BOTTOM_NAVIGATION_ITEMS.ARTICLES
  return (
    <BottomNavigationWrapper id="bottomNavigationMobile">
      {Object.values(BOTTOM_NAVIGATION_ITEM_PROPERTIES)?.map((navigationItem: INavigationItem) => (
        <NavigationItem
          key={navigationItem?.title}
          title={navigationItem?.title}
          Icon={navigationItem?.Icon}
          url={navigationItem?.url}
          eventName={navigationItem?.eventName}
          eventProperties={navigationItem?.eventProperties}
          isActive={activeTab === navigationItem.title}
        />
      ))}
    </BottomNavigationWrapper>
  )
}
